<template>
  <div>
    <flow-step-base
      name="Freeform Feedback"
      :guid="step.guid"
      :imgPath="img"
      description="Give customers a chance to give you raw, unfiltered feedback."
      @disable="$emit('update', { enabled: false })"
      @rework="$emit('rework')"
    >
      <div class="mt-4">
        <p class="text-sm font-semibold mb-2 text-gray-700">What do you want this step to say?</p>
        <el-input
          type="text"
          placeholder="Headline"
          :value="step.header"
          @input="(header) => $emit('update', { header })"
          maxlength="80"
          show-word-limit
        >
        </el-input>
        <div style="margin: 20px 0"></div>
        <Editor :placeholder="step.description" :maxlength="0" @update="(description) => $emit('update', { description })" />
      </div>
      <div class="mt-4">
        <div>
          <p class="text-sm font-semibold mb-2 text-gray-700">Require freeform feedback?</p>
          <el-switch
            :value="step.freeformConfig.inputRequired"
            @change="(inputRequired) => $emit('update', { inputRequired, minLength: step.freeformConfig.minLength || 40 }, 'freeformConfig')"
            active-text="Yes"
            inactive-text="No"
          ></el-switch>
        </div>
        <el-collapse-transition>
          <div class="mt-3" v-show="step.freeformConfig.inputRequired">
            <p class="text-sm font-semibold mb-2 text-gray-700">Minimum character length</p>
            <el-input-number
              :value="step.freeformConfig.minLength"
              :step="10"
              @change="(minLength) => $emit('update', { inputRequired: true, minLength }, 'freeformConfig')"
              :min="0"
              :max="400"
            >
            </el-input-number>
          </div>
        </el-collapse-transition>
      </div>
    </flow-step-base>
  </div>
</template>

<script>
import FlowStepBase from '@/components/FlowSteps/FlowStepBase.vue';
import Editor from '@/components/UI/Editor.vue';
import img from '@/assets/img/icon-openended.svg';

export default {
  name: 'FlowStepFreeform',
  components: {
    FlowStepBase,
    Editor,
  },
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      img,
    };
  },
};
</script>
